export default {
  financiamentos: []
}
